module.exports = __webpack_public_path__ + "static/media/left.09bab6cd.svg";